<template>
  <aside class="app-sidebar noprint">
    <div class="app-sidebar__wrapper">
      <ul>
        <li
          v-for="item in sidebarItems"
          :key="item.href">
          <a
            :href="item.href"
            class="app-sidebar__item"
            :class="{ active: item.active }">
            <i
              v-if="item.icon"
              :class="item.icon" />
            <span>{{ item.label }}</span>
          </a>
        </li>
      </ul>
    </div>
  </aside>
</template>

<script setup>
import { computed } from 'vue'
import { useGlobalStore } from '@/stores/global'

const globalStore = useGlobalStore()

const sidebarItems = computed(() => (globalStore.sidebar?.items || [])
  .filter((item) => !item.show || item.show(globalStore)))
</script>
